const initialState = {
  isNewGroup: false,
  groupName: null,
  description: null,
};

export default initialState;
